import { render, staticRenderFns } from "./SemiDonut.vue?vue&type=template&id=5115b3ad&scoped=true&"
import script from "./SemiDonut.vue?vue&type=script&lang=js&"
export * from "./SemiDonut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5115b3ad",
  null
  
)

export default component.exports